import React from 'react'
import client from '../../vendors/algolia';
import {
  InstantSearch,
  Configure,
} from 'react-instantsearch-dom';
import CustomSearchBox from './SearchBox';
import { CustomHits } from './ProjectHit';
import Grid from '../ui-kit/layout/Grid';


interface Props {
  index: string
}


const AlgoliaSearchBar: React.FC<Props> = ({ index }) => {
  let indexName = (process.env.NEXT_PUBLIC_ALGOLIA_PREFIX || 'dev') + '_' + index;

  return (
    <div className="">
      <InstantSearch indexName={indexName} searchClient={client}>
        <Configure hitsPerPage={5} />
        <CustomSearchBox
          autoFocus={true}
          searchAsYouType={true}
          showLoadingIndicator={true}
          translations={{
            placeholder: 'ReactJs, Python, Ciencia de datos...',
            resetTitle: 'Limpiar busqueda',
            submitTitle: 'Buscar',
          }}
        />
        <div className="my-8">
          <Grid title="Resultados">
            <CustomHits />
          </Grid>
        </div>
      </InstantSearch>
    </div>
  )
}


export default AlgoliaSearchBar;